import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { EpimsGenderDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-gender-view',
  templateUrl: './gender-view.component.html',
  styleUrls: ['./gender-view.component.css'],
})
export class GenderViewComponent implements OnInit {
  @Input() genders: EpimsGenderDto[];
  genderForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<EpimsGenderDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.genderForm = this.fb.group({ Genders: this.fb.array([]) });
    this.setGender();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display genders
  setGender() {
    const control = this.genderForm.controls.Genders as FormArray;
    this.genders.forEach((e) => {
      control.push(
        this.fb.group({
          GenderName: e.GenderName,
          id: e.id,
        })
      );
    });
  }

  // method to add Gender
  addGender() {
    const control = this.genderForm.controls.Genders as FormArray;
    control.insert(
      0,
      this.fb.group({
        GenderName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete gender from arrary list
  deleteGender(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.genderForm.controls.Genders as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.genders.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.genders[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'gender';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('gender');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
